<template>
  <div>
    <Navbar />
    <DynamicHeader :title="headerTitle" :image="headerImage" />
    <DynamicContent :slug="slug" @page-loaded="onPageLoaded" />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import DynamicHeader from '@/components/DynamicPage/Header.vue'
import DynamicContent from '@/components/DynamicPage/Content.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'DynamicPage',
  components: { Navbar, DynamicHeader, DynamicContent, Footer },
  data() {
    return {
      headerTitle: '',
      headerImage: ''
    }
  },
  computed: {
    slug() {
      return this.$route.params.slug || '';
    }
  },
  methods: {
    onPageLoaded({ title, image }) {
      this.headerTitle = title;
      this.headerImage = image;
      document.title = title + ' | Al Shola School';
    }
  }
}
</script>
